import { PageError } from 'utils/errors';

export const NotFoundPage = () => {
	throw new PageError('404 Not Found');
};
